import { Injectable } from "@angular/core";

declare var Swiper: any; // CDN global variable

@Injectable({
    providedIn: "root",
})
export class SwiperService {
    initSwiper(container: HTMLElement, config: any = {}): any {
        return new Swiper(container, {
            // Modules not needed — swiper-bundle includes everything
            watchOverflow: true,
            navigation: {
                nextEl: container.querySelector(".swiper-button-next"),
                prevEl: container.querySelector(".swiper-button-prev"),
                disabledClass: "swiper-button-disabled",
            },
            ...config,
        });
    }
}
